import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import DataTable from "../ManageSettings/DataTables";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AddDepartmentModal from "../ReusableForm/AddDepartmentModal";
import AddVendorModal from "../ReusableForm/AddVendorModal";
import { useNavigate } from "react-router-dom";
import invoiceIcon from "../../../../assets/Image/invoiceIcon.png";
import vendor from "../../../../assets/Image/vendor.png";
import department from "../../../../assets/Image/Department.png";
import CloseIcon from "../../../../assets/Image/close.png";
import { useToastHandler } from "../../../common/ToastHandler";
import { ToastContainer } from "react-toastify";
import useSwal from "../../../common/ReusableComponent/useSwal";
import useFormattingUtils from "../../../../context/useFormattingUtils";
import ChequeRenderer from "../Payroll/Cheque Layout/ChequeRenderer";
import PaginatedSearchSelect from "../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";
export default function Purchase() {
  const { user } = useContext(AuthContext);
  const storeId = user.store;
  const navigate = useNavigate();
  const { formatDate } = useFormattingUtils();
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [showCheckFields, setShowCheckFields] = useState(false);
  const [showBankFields, setShowBankFields] = useState(false);
  const [showModalDepartment, setShowModalDepartment] = useState(false);
  const [showModalVendor, setShowModalVendor] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [dueDays, setDueDays] = useState([]);
  const [bank, setBank] = useState([]);
  const [selectedChequeLayout, setSelectedChequeLayout] = useState(null);
  const today = new Date().toISOString().split("T")[0];
  const [, setInvoicesPurchase] = useState([]);
  const [totalPaidPurchase, setTotalPaidPurchase] = useState(0.0);
  const [totalReceivedCreditPurchase, setTotalReceivedCreditPurchase] =
    useState(0.0);
  const [totalUnpaidForPurchases, setTotalUnpaidForPurchases] = useState(0.0);
  const [totalOutstandingPurchase, setTotalOutstandingPurchase] = useState(0.0);
  const [totalDueForPurchases, setTotalDueForPurchases] = useState(0.0);
  const [totalPurchaseCredit, setTotalPurchaseCredit] = useState(0.0);
  const [totalPurchase, setTotalPurchase] = useState(0.0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [, setTotalCount] = useState(0);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [editingInvoiceId, setEditingInvoiceId] = useState(null);
  const { Post, _Get, GetPaginatedData } = useApi();
  const [reloadTotal, setReloadTotal] = useState(false);
  const [filteredDepartments, setFilteredDepartments] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");

  const [formData, setFormData] = useState({
    type: "purchase",
    store: storeId,
    invoice_no: "",
    date: today,
    status: "",
    pay_method_status: "pay_now",
    pay_method: "cash",
    amount: "",
    pay_amount: null,
    discount: null,
    remaining_amount: "",
    after_discount: null,
    prepaid_tax: false,
    prepaid_tax_percentage: "",
    vendor_department: "",
    vendor_department_name: "",
    cheque_no: "",
    note: "",
    due_date: null,
    bank: "",
    cheque_layout: null
  });
  const [reloadData, setReloadData] = useState(false);
  const { confirmDelete } = useSwal();
  const { handleToast } = useToastHandler();

  const chequePreviewData = {
    name: formData.vendor_department_name || "",
    amount: formData.amount || "0.00",
    date: formData.date || today,
    chequeNumber: formData.cheque_no || "",
  };


  useEffect(() => {
    if (formData.date && formData.due_date) {
      const startDate = new Date(formData.date);
      const dueDate = new Date(formData.due_date);

      const timeDiff = dueDate - startDate;
      const daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));

      setFormData((prevData) => ({
        ...prevData,
        days: daysDiff,
      }));
    }
  }, [formData.date, formData.due_date]);

  const getInvoiceData = async (page = 1, search = "") => {
    setIsLoadingData(true);
    try {
      const response = await GetPaginatedData("invoiceData", {
        page: page,
        search: search,
        queryParams: {
          type: "purchase"
        }
      });

      const activeInvoices = response.data.filter((invoice) => !invoice.is_deleted);
      setInvoices(activeInvoices);

      setTotalPages(response.totalPages || Math.ceil(response.totalCount / 10) || 1);
      setTotalCount(response.totalCount || activeInvoices.length);
    } catch (error) {
      console.error("Error fetching invoices:", error);
      handleToast({
        type: "ERROR",
        message: "Error fetching invoices.",
      });
    } finally {
      setIsLoadingData(false);
    }
  };

  useEffect(() => {
    getInvoiceData(currentPage, searchTerm);
  }, [reloadData, currentPage, searchTerm]);
  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      prepaid_tax: checked,
    }));
  };

  const updateVendors = (newVendor) => {
    setVendors((prev) => [...prev, newVendor]);
  };

  const handleNewDepartment = (newDepartment) => {
    const updatedServiceData = [
      ...serviceData,
      {
        id: newDepartment.id,
        title: newDepartment.title,
        type: "department",
      },
    ];

    setServiceData(updatedServiceData);

    setFormData((prevData) => ({
      ...prevData,
      department: "",
    }));

    setShowModalDepartment(false);
  };
  const handleServiceDataUpdate = (updateFunction) => {
    setServiceData(updateFunction);
  };

  const fetchData = async () => {
    try {
      const [vendorsResponse, serviceResponse, dueDaysResponse, bankResponse] =
        await Promise.all([
          GetPaginatedData("vendorDepartmentData"),
          GetPaginatedData("vendorDepartmentServiceData"),
          GetPaginatedData("dueDaysData"),
          GetPaginatedData("bank"),
        ]);
      setVendors(vendorsResponse.data || []);
      setServiceData(serviceResponse.data || []);
      setDueDays(dueDaysResponse.data || []);
      setBank(bankResponse.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      handleToast({
        type: "ERROR",
        message: "Error fetching data.",
      });
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const [loading, setLoading] = useState(false);
  const getPurchaseCalculation = async () => {
    setLoading(true);
    _Get("purchaseCalculation")
      .then((response) => {
        setInvoicesPurchase(response);
        setTotalPaidPurchase(response.total_paid);
        setTotalReceivedCreditPurchase(response.total_received_credit);
        setTotalUnpaidForPurchases(response.total_unpaid);
        setTotalOutstandingPurchase(response.total_outstanding_credit);
        setTotalDueForPurchases(response.total_due);
        setTotalPurchaseCredit(response.total_credit);
        setTotalPurchase(response.total_purchase || 0);
      })
      .catch((error) => {
        console.error("Error fetching invoices:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getPurchaseCalculation();
  }, [reloadTotal]);

  useEffect(() => {
    handlePaymentMethodChange({
      target: { name: "pay_method_status", value: formData.pay_method_status },
    });
    handleSpecificPaymentMethodChange({
      target: { name: "pay_method", value: formData.pay_method },
    });
  }, []);

  const handlePaymentMethodChange = (e) => {
    const value = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      pay_method_status: value,
      pay_method:
        value === "pay_later"
          ? "pay_later"
          : value === "credit_invoice"
            ? "credit_invoice"
            : "",
      status: value === "pay_now" ? "paid" : "unpaid",
    }));
    setShowPaymentOptions(value === "pay_now");
    setShowAdditionalFields(
      value === "credit_invoice" || value === "pay_later"
    );
    setShowCheckFields(false);
    setShowBankFields(false);
  };

  const handleSpecificPaymentMethodChange = (e) => {
    const value = e.target.value;
    setSelectedPaymentMethod(value);
    setShowCheckFields(value === "cheque");
    setShowBankFields(value === "bank");

    if (value !== "cheque") {
      setSelectedChequeLayout(null)
    }
    setFormData((prevData) => ({
      ...prevData,
      pay_method: value,
    }));
  };

  const toggleModal = () => {
    setShowModal(!showModal);
    if (showModal) {
      setFormData({
        type: "purchase",
        invoice_no: "",
        date: today,
        status: "",
        pay_method_status: "pay_now",
        pay_method: "cash",
        amount: "",
        pay_amount: null,
        discount: null,
        remaining_amount: "",
        after_discount: null,
        prepaid_tax: false,
        vendor_department: "",
        vendor_department_name: "",
        cheque_no: "",
        note: "",
        due_date: "",
        bank: "",
      });
      setEditingInvoiceId(null);
    }
  };
  const handleCloseModal = () => {
    setShowModalDepartment(false);
  };
  const handleShowVendor = () => setShowModalVendor(true);
  const handleCloseVendor = () => {
    setShowModalVendor(false);
  };
  const handleVendorAdded = (newVendor) => {
    setVendors((prevVendors) => [...prevVendors, newVendor]);
    setFormData({ ...formData, vendor_department: newVendor.id });
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    const updatedData = {
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    };

    if (value === "add-department") {
      setShowModalDepartment(true);
      return;
    }

    if (name === "vendor_department") {
      const selectedVendor = vendors.find((vendor) => vendor.id === value);

      updatedData.vendor_department_name = selectedVendor?.name || "";

      const vendorDepartments = serviceData.filter(
        (service) =>
          selectedVendor?.vendor_department_service_title?.includes(
            service.title
          ) && service.type === "department"
      );

      setFilteredDepartments(vendorDepartments);

      if (vendorDepartments.length > 0) {
        updatedData.vendor_department_service_titles =
          vendorDepartments[0].title;
      } else {
        updatedData.vendor_department_service_titles = "";
      }
    }

    if (name === "vendor_department_service_titles") {
      updatedData.vendor_department_service_titles = value;
    }

    if (name === "days") {
      const selectedDueDays = parseInt(value, 10);
      if (!isNaN(selectedDueDays)) {
        const today = new Date();
        const dueDate = new Date(today);
        dueDate.setDate(dueDate.getDate() + selectedDueDays);
        updatedData.due_date = dueDate.toISOString().split("T")[0];
      }
    }

    setFormData(updatedData);
  };

  const handleOpenDepartmentPopUp = () => {
    setShowModalDepartment(true);
  };

  const handleOpenPurchaseVendorPopUp = () => {
    setShowModalVendor(true);
  };

  const handleEdit = async (invoice) => {
    if (invoice.status === "partially_paid") {
      handleToast({
        type: "ERROR",
        message: "Cannot edit partially paid invoice.",
      });
      return;
    }

    const updatedFormData = {
      ...invoice,
      vendor_department_name:
        vendors.find((v) => v.id === invoice.vendor_department)?.name || "",
      vendor_department_service_titles:
        invoice.vendor_department_service_titles || "",
      due_date: invoice.due_date || "",
      amount: invoice.amount || "",
    };

    setFormData(updatedFormData);
    setEditingInvoiceId(invoice.id);
    setShowModal(true);

    if (invoice.pay_method === "cheque") {
      setShowCheckFields(true);
      setShowBankFields(false);
      setSelectedPaymentMethod("cheque");

      const res = await GetPaginatedData("preferenceCompanyData");
      const matchedLayout = res.data.find(
        (l) => l.id === invoice.cheque_layout
      );

      setSelectedChequeLayout(matchedLayout || null);
    } else {
      setSelectedChequeLayout(null);
    }
  };


  const handleDelete = async (id) => {
    const result = await confirmDelete();
    if (!result.isConfirmed) return;
    try {
      const payload = {
        invoice_id: id,
        is_deleted: true,
      };
      await Post(`deleteInvoice`, payload);

      handleToast({
        type: "SUCCESS",
        message: "Invoice deleted successfully!",
      });

      setReloadData(!reloadData);
      //  Restore cheque fields + layout
      if (formData.pay_method === "cheque") {
        setShowCheckFields(true);

        GetPaginatedData("preferenceCompanyData").then((res) => {
          const matchedLayout = res.data.find(
            (l) => l.id === formData.cheque_layout
          );

          setSelectedChequeLayout(matchedLayout || null);
        });
      } else {
        setSelectedChequeLayout(null);
      }

      await getPurchaseCalculation();
    } catch (error) {
      console.error("Error deleting invoice:", error);
      handleToast({
        type: "ERROR",
        message: "Error deleting invoice: " +
          (error.response ? error.response.data : error.message)
      });

    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let updatedRemainingAmount = 0;
    if (
      formData.pay_method === "pay_later" &&
      formData.pay_method_status === "pay_later"
    ) {
      updatedRemainingAmount =
        parseFloat(formData.amount) - parseFloat(formData.pay_amount || 0);
    }
    else {
      updatedRemainingAmount = 0;
    }

    formData.remaining_amount =
      updatedRemainingAmount >= 0 ? updatedRemainingAmount.toFixed(2) : "0.00";

    if (!editingInvoiceId) {
      const isDuplicateInvoiceNo = invoices.some(
        (invoice) => invoice.invoice_no === formData.invoice_no
      );
      if (isDuplicateInvoiceNo) {

        handleToast({
          type: "ERROR",
          message: "Invoice number must be unique."
        });
        return;
      }
    }

    if (!formData.vendor_department) {

      handleToast({
        type: "ERROR",
        message: "Please Select a Vendor.",
      });
      return;
    }
    if (!formData.invoice_no) {

      handleToast({
        type: "ERROR",
        message: "Invoice number is required.",
      });
      return;
    }
    if (!formData.vendor_department_service_titles) {

      handleToast({
        type: "ERROR",
        message: "Please select a department",
      });
      return;
    }
    if (formData.pay_method_status === "pay_later") {
      if (!formData.pay_method) {

        handleToast({
          type: "ERROR",
          message: "Please select a payment method",
        });
        return;
      }

      if (!formData.due_date) {

        handleToast({
          type: "ERROR",
          message: "Please select a Due Date",
        });
        return;
      }
      if (!formData.amount) {

        handleToast({
          type: "ERROR",
          message: "Please fill in the Amount",
        });
        return;
      }
    }

    if (formData.pay_method_status === "pay_now") {
      if (!formData.pay_method) {

        handleToast({
          type: "ERROR",
          message: "Please select a payment method",
        });
        return;
      }

      if (formData.pay_method === "cash") {
        if (!formData.amount) {

          handleToast({
            type: "ERROR",
            message: "Please fill in the Amount",
          });
          return;
        }
      }

      if (formData.pay_method_status === "pay_now") {
        if (!formData.pay_method) {

          handleToast({
            type: "ERROR",
            message: "Please select a payment method.",
          });
          return;
        }

        if (formData.pay_method === "bank") {
          if (!formData.bank) {

            handleToast({
              type: "ERROR",
              message: "Please select a Bank.",
            });
            return;
          }
          if (!formData.amount) {

            handleToast({
              type: "ERROR",
              message: "Please fill in the Amount",
            });
            return;
          }
        }
      }

      formData.due_date = null;

      if (formData.pay_method_status === "pay_now") {
        if (!formData.pay_method) {

          handleToast({
            type: "ERROR",
            message: "Please select a payment method",
          });
          return;
        }

        if (formData.pay_method === "cheque") {
          if (!formData.bank) {

            handleToast({
              type: "ERROR",
              message: "Please select a Bank.",
            });
            return;
          }

          if (!formData.cheque_no) {

            handleToast({
              type: "ERROR",
              message: "Please fill in the Cheque No.",
            });
            return;
          }
          if (!formData.amount) {

            handleToast({
              type: "ERROR",
              message: "Please fill in the Amount.",
            });
            return;
          }
        }
      }
    }

    const updatedFormData = {
      ...formData,
      amount: formData.amount,
      pay_amount: formData.pay_amount || formData.amount,
    };

    if (formData.pay_method_status === "pay_now") {
      updatedFormData.status = "paid";

      updatedFormData.due_date = null;
    }

    try {
      let response;
      if (editingInvoiceId) {
        const originalInvoice = invoices.find(
          (invoice) => invoice.id === editingInvoiceId
        );
        if (!originalInvoice) {
          console.error(
            "Invoice not found for editingInvoiceId:",
            editingInvoiceId
          );
          handleToast({
            type: "ERROR",
            message: "Invoice not found for editingInvoiceId: " + editingInvoiceId
          });
          return;
        }

        const newRemainingAmount = Math.max(
          0,
          originalInvoice.amount - (formData.pay_amount || 0)
        );
        let newStatus = originalInvoice.status;

        if (formData.pay_method_status === "pay_now") {
          newStatus = "paid";
        } else if (formData.pay_method_status === "pay_later") {
          newStatus = "unpaid";
        } else if (newRemainingAmount < originalInvoice.amount) {
          newStatus = "partially_paid";
        }

        updatedFormData.pay_amount =
          formData.pay_amount !== undefined
            ? formData.pay_amount
            : formData.remaining_amount;

        if (formData.pay_method_status === "pay_now") {
          updatedFormData.status = "paid";
        }
        if (formData.pay_method_status === "pay_later") {
          updatedFormData.status = "unpaid";
        }
        const updatedInvoice = {
          ...updatedFormData,

          cheque_layout:
            formData.pay_method === "cheque"
              ? selectedChequeLayout?.id || null
              : null,

          invoice_id: editingInvoiceId,

          status: newStatus,
        };

        response = await Post("editInvoice", updatedInvoice);

        if (response.status === 200) {
          setInvoices((prevInvoices) =>
            prevInvoices.map((invoice) =>
              invoice.id === editingInvoiceId
                ? { ...invoice, ...updatedInvoice }
                : invoice
            )
          );

          handleToast({
            type: "SUCCESS",
            message: "Invoice updated successfully!",
          });
          setReloadData(!reloadData);
          setReloadTotal(!reloadTotal);
          toggleModal();
        }
      } else {
        const duplicateInvoice = invoices.some(
          (invoice) => invoice.invoice_no === formData.invoice_no
        );
        if (duplicateInvoice) {

          handleToast({
            type: "ERROR",
            message: "Invoice number must be unique!",
          });
          return;
        }

        const newInvoiceData = {
          ...updatedFormData,

          cheque_layout:
            formData.pay_method === "cheque"
              ? selectedChequeLayout?.id || null
              : null,

          remaining_amount:
            formData.pay_method_status === "pay_now" ? "0.00" : formData.amount,
          status: formData.pay_method_status === "pay_now" ? "paid" : "unpaid",
        };

        response = await Post("createInvoiceAndPrepaidTax", newInvoiceData);
        if (response.status === 200 || response.status === 201) {

          handleToast({
            type: "SUCCESS",
            message: "Invoice submitted successfully!",
          });
          setReloadData(!reloadData);
          setReloadTotal(!reloadTotal);
          toggleModal();
        }
      }
    } catch (error) {
      console.error("Error submitting invoice:", error);

      handleToast({
        type: "ERROR",
        message: "Error submitting invoice:" + (error.response ? error.response.data : error.message)
      })
    }
  };

  const handleSearch = (searchValue) => {
    setSearchTerm(searchValue);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const purchaseInvoice = invoices.filter(
    (invoice) => invoice.type === "purchase" && !invoice.is_deleted
  );
  const formattedPurchaseInvoices = purchaseInvoice.map(item => ({
    ...item,
    date: item.date ? formatDate(item.date) : "N/A",
    due_date: item.due_date ? formatDate(item.due_date) : "-"
  }));

  const columns = [
    { header: "Date", field: "date" },
    { header: "Invoice Number", field: "invoice_no" },
    { header: "Vendor Name", field: "vendor_department_name" },
    { header: "Departments", field: "vendor_department_service_titles" },

    { header: "Due Date", field: "due_date" },
    { header: "Amount", field: "amount" },
    { header: "Remaining Amount", field: "remaining_amount" },
    { header: "Payment Method", field: "pay_method" },
    { header: "Status", field: "status" },
  ];

  return (
    <div className="responsive-box">
      <div>
        <div className="">
          <div
            className="d-flex align-items-center mb-3"
            style={{
              justifyContent: "space-between",
              gap: "10px",
              marginBottom: "10px",
            }}
          >
            <h3 className="mb-1" style={{ margin: "0px" }}>
              Purchase
            </h3>
            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
              <button
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#4A5546",
                  boxShadow: "none",
                  outline: "none",
                  width: "auto",
                  height: "42px",
                  padding: "8px 12px",
                  fontSize: "14px",
                  border: "none",
                  borderRadius: "10px",
                  color: "#F4FFEE",
                  fontWeight: "bold",
                  cursor: "pointer",
                  gap: "8px",
                }}
                onClick={handleOpenDepartmentPopUp}
              >
                Add Department
                <img
                  src={department}
                  alt="Department Icon"
                  style={{ width: "20px", height: "20px", marginLeft: "8px" }}
                />
              </button>
              <button
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#4A5546",
                  boxShadow: "none",
                  outline: "none",
                  width: "auto",
                  height: "42px",
                  padding: "8px 12px",
                  fontSize: "14px",
                  border: "none",
                  borderRadius: "10px",
                  color: "#F4FFEE",
                  cursor: "pointer",
                  fontWeight: "bold",
                  gap: "8px",
                }}
                onClick={handleOpenPurchaseVendorPopUp}
              >
                Add New Vendor
                <img
                  src={vendor}
                  alt="Vendor Icon"
                  style={{ width: "20px", height: "20px", marginLeft: "8px" }}
                />
              </button>

              <button
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#FFAF32",
                  boxShadow: "none",
                  outline: "none",
                  width: "auto",
                  height: "42px",
                  padding: "8px 12px",
                  fontSize: "14px",
                  border: "none",
                  borderRadius: "10px",
                  fontWeight: "bold",
                  color: "#000",
                  cursor: "pointer",
                  gap: "8px",
                }}

                onClick={() => navigate("/purchase-invoice")}
              >
                {" "}
                Add Purchase Invoice
                <img
                  src={invoiceIcon}
                  alt="Invoice Icon"
                  style={{ width: "20px", height: "20px" }}
                />
              </button>
            </div>
          </div>

          { }
          <div className="table-responsive">
            <DataTable
              data={formattedPurchaseInvoices}
              columns={columns}
              showAction={true}
              showFooter={true}
              onEdit={handleEdit}
              onDelete={handleDelete}
              totals={{
                totalPaidPurchase,
                totalReceivedCreditPurchase,
                totalUnpaidForPurchases,
                totalOutstandingPurchase,
                totalDueForPurchases,
                totalPurchaseCredit,
                totalPurchase,
              }}
              loading={loading || isLoadingData}
              enableServerSideSearch={true}
              onSearch={handleSearch}
              onPageChange={handlePageChange}
              currentPage={currentPage}
              totalPages={totalPages}
              searchTerm={searchTerm}
            />
          </div>

          {showModal && (
            <div className="modal-overlay" onClick={toggleModal}>
              <div
                className="modal-container"
                onClick={(e) => e.stopPropagation()}
                style={{
                  width: "1200px",
                  backgroundColor: "white",
                  margin: "100px auto",

                  borderRadius: "40px",
                  position: "relative",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              >
                <div className="modal-header" style={{ border: "none" }}>
                  <h5
                    className="modal-title p-2"
                    style={{ fontWeight: "bold" }}
                  >
                    {editingInvoiceId ? "Edit Purchase" : "Add New Purchase"}
                  </h5>
                  <img
                    src={CloseIcon}
                    alt="Close"
                    width="34"
                    height="34"
                    onClick={toggleModal}
                  />
                </div>
                <div className="modal-body"
                  style={{
                    maxHeight: "70vh",
                    overflowY: "auto",
                  }}
                >
                  <form>
                    <div
                      className="form-row form-group col-md-12 d-flex position-relative"
                      style={{ gap: "90px", padding: "0 10px" }}
                    >
                      <div className="col-md-5" style={{ padding: "0" }}>
                        <input
                          style={{
                            backgroundColor: "#ffffff",
                            border: "none",
                            borderBottom: "1px solid #ccc",
                            borderRadius: "0px",
                            height: "52px",
                            width: "100%",
                            marginLeft: "30px",
                          }}
                          type="date"
                          className="form-control-borderless"
                          id="billDate"
                          name="date"
                          value={formData.date || today}
                          onChange={handleChange}
                          required
                          disabled={editingInvoiceId ? true : false}
                        />
                      </div>
                      <div className="col-md-5" style={{ padding: "0" }}>
                        <input
                          style={{
                            backgroundColor: "#ffffff",
                            border: "none",
                            borderBottom: "1px solid #ccc",
                            borderRadius: "0px",
                            height: "52px",
                            width: "100%",
                          }}
                          type="text"
                          className="form-control-borderless"
                          name="invoice_no"
                          disabled={editingInvoiceId ? true : false}
                          placeholder="Invoice Number"
                          value={formData.invoice_no}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    { }
                    <div className="d-flex col-md-12" style={{ gap: "90px", marginLeft: '2px' }}>
                      <div
                        className="col-md-5"
                        style={{ paddingRight: "10px" }}
                      >
                        <select
                          style={{
                            backgroundColor: "#ffffff",

                            height: "52px",
                            marginLeft: "38px",
                          }}
                          className="input-select"
                          disabled={editingInvoiceId ? true : false}
                          name="vendor_department"
                          value={formData.vendor_department}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            if (selectedValue === "add-vendor") {
                              handleShowVendor();
                              setFormData((prevData) => ({
                                ...prevData,
                                vendor_department: "",
                              }));
                            } else {
                              handleChange(e);
                            }
                          }}
                        >
                          <option value="">Select Vendor</option>
                          <option value="add-vendor">Add Vendor</option> { }
                          {vendors
                            .filter(
                              (vendor) =>
                                vendor.type === "purchase" && !vendor.is_deleted
                            )
                            .map((vendor) => (
                              <option key={vendor.id} value={vendor.id}>
                                {vendor.name}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div
                        className="col-md-5"
                        style={{ paddingRight: "10px" }}
                      >
                        <select
                          className="input-select"
                          style={{
                            backgroundColor: "#ffffff",

                            height: "52px",
                          }}
                          name="vendor_department_service_titles"
                          value={formData.vendor_department_service_titles}
                          onChange={handleChange}
                          id="expenseType"
                          required
                          disabled={editingInvoiceId ? true : false}
                        >
                          <option value="">Select Department</option>
                          <option value="add-department">Add Department</option>
                          {filteredDepartments.length > 0
                            ? filteredDepartments.map((department) => (
                              <option
                                key={department.id}
                                value={department.title}
                              >
                                {department.title}
                              </option>
                            ))
                            : serviceData
                              .filter(
                                (service) => service.type === "department"
                              )
                              .map((service) => (
                                <option
                                  key={service.id}
                                  value={
                                    service.vendor_department_service_titles
                                  }
                                >
                                  {service.title}
                                </option>
                              ))}
                        </select>
                      </div>
                    </div>
                    <div className="d-flex col-md-12 mt-2 gap-4 " style={{ marginLeft: '32px' }}>
                      <div className="form-row d-flex col-md-5 p-2 mt-2">
                        <div className="input-group"  >
                          <div
                            className="input-group-prepend"
                            style={{
                              background: "#ffffff",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              marginLeft: "30px",
                            }}
                          >
                            { }
                          </div>
                          <input
                            required
                            className="form-control-borderless"
                            placeholder="Amount"
                            aria-label="Amount"
                            aria-describedby="addon-wrapping"
                            name={editingInvoiceId ? "amount" : "amount"}
                            value={
                              editingInvoiceId &&
                                formData.pay_amount === undefined
                                ? formData.remaining_amount
                                : formData.pay_amount || formData.amount
                            }
                            onChange={handleChange}
                            onInput={(e) => {
                              e.target.value = e.target.value
                                .replace(/[^0-9.]/g, "")
                                .replace(/^(\d*\.?\d{0,2}).*/g, "$1")
                                .slice(0, 12);
                            }}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          border: "1px solid #ACB4AA",
                          padding: "5px 6px",
                          marginTop: "20px",
                          width: "fit-content",
                          borderRadius: "40px",
                          display: "flex",
                          gap: "10px",
                        }}
                      >
                        {[
                          { value: "pay_now", label: "Pay Now" },
                          { value: "pay_later", label: "Pay Later" },
                          { value: "credit_invoice", label: "Credit Invoice" },
                        ].map((option) => (
                          <label
                            key={option.value}
                            className="radio-inline"
                            style={{
                              backgroundColor:
                                formData.pay_method_status === option.value
                                  ? "#4a5546"
                                  : "transparent",
                              color:
                                formData.pay_method_status === option.value
                                  ? "white"
                                  : "black",
                              padding: "5px 20px",
                              borderRadius: "20px",
                              cursor: editingInvoiceId
                                ? "not-allowed"
                                : "pointer",
                            }}
                          >
                            <input
                              type="radio"
                              name="pay_method_status"
                              value={option.value}
                              checked={
                                formData.pay_method_status === option.value
                              }
                              onChange={handlePaymentMethodChange}
                              disabled={!!editingInvoiceId}
                              style={{
                                opacity: 0,
                                position: "absolute",
                                pointerEvents: "auto",
                              }}
                            />
                            {option.label}
                          </label>
                        ))}
                      </div>
                    </div>

                    {showPaymentOptions && (
                      <div
                        className="d-flex col-md-6 mb-3"
                        style={{
                          border: "1px solid #ACB4AA",
                          padding: "5px 6px",
                          width: "fit-content",
                          borderRadius: "40px",
                          display: "flex",
                          gap: "10px",
                          marginTop: "20px",
                          marginLeft: "34px",
                        }}
                      >
                        <div
                          className="payment-option"
                          onClick={() =>
                            handleSpecificPaymentMethodChange({
                              target: { value: "cash" },
                            })
                          }
                          style={{
                            padding: "5px 20px",
                            cursor: "pointer",
                            borderRadius: "20px",
                            backgroundColor:
                              selectedPaymentMethod === "cash"
                                ? "#4a5546"
                                : "transparent",
                            color:
                              selectedPaymentMethod === "cash"
                                ? "white"
                                : "black",
                            textAlign: "center",
                          }}
                        >
                          Cash
                        </div>
                        <div
                          className="payment-option"
                          onClick={() =>
                            handleSpecificPaymentMethodChange({
                              target: { value: "cheque" },
                            })
                          }
                          style={{
                            padding: "5px 20px",
                            cursor: "pointer",
                            borderRadius: "20px",
                            backgroundColor:
                              selectedPaymentMethod === "cheque"
                                ? "#4a5546"
                                : "transparent",
                            color:
                              selectedPaymentMethod === "cheque"
                                ? "white"
                                : "black",
                            textAlign: "center",
                          }}
                        >
                          Check
                        </div>
                        <div
                          className="payment-option"
                          onClick={() =>
                            handleSpecificPaymentMethodChange({
                              target: { value: "bank" },
                            })
                          }
                          style={{
                            padding: "5px 20px",
                            cursor: "pointer",
                            borderRadius: "20px",
                            backgroundColor:
                              selectedPaymentMethod === "bank"
                                ? "#4a5546"
                                : "transparent",
                            color:
                              selectedPaymentMethod === "bank"
                                ? "white"
                                : "black",
                            textAlign: "center",
                          }}
                        >
                          Bank Card/ACH/EFT
                        </div>
                      </div>
                    )}

                    {showAdditionalFields && (
                      <div
                        className="d-flex col-md-5 mt-2"
                        style={{ marginTop: "20px", marginLeft: "37px" }}
                      >
                        <select
                          className="form-control-borderless col-md-4 me-2"
                          name="days"
                          value={formData.days || ""}
                          onChange={handleChange}
                          style={{
                            backgroundColor: "#fff",

                            borderBottom: "1px solid #ccc",
                            borderRadius: "0px",
                            height: "52px",
                          }}
                          required
                        >
                          <option value="">Select Due Days</option>
                          {dueDays.map((day) => (
                            <option key={day.id} value={day.value}>
                              {day.days}
                            </option>
                          ))}
                        </select>
                        { }
                      </div>
                    )}


                    {showCheckFields && (

                      <>
                        <div
                          className="d-flex col-md-10 mt-2"
                          style={{ marginLeft: "10px" }}
                        >
                          <div className="d-flex col-md-4 mt-2">
                            <select
                              style={{
                                backgroundColor: "#fff",
                                border: "none",
                                borderBottom: "1px solid #ccc",
                                borderRadius: "0px",
                                height: "52px",
                                marginLeft: "13px",
                              }}
                              className="input-select"
                              name="bank"
                              value={formData.bank}
                              onChange={handleChange}
                            >
                              <option value="">Select Bank</option>
                              {bank.map((bank) => (
                                <option key={bank.id} value={bank.id}>
                                  {bank.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="d-flex col-md-4 mt-2">
                            <input
                              type="text"
                              className="form-control-borderless me-2"
                              placeholder="Check Number"
                              style={{
                                backgroundColor: "#fff",
                                border: "none",
                                borderBottom: "1px solid #ccc",
                                borderRadius: "0px",
                                height: "52px",
                                marginRight: "10px",
                              }}
                              id="checkNumber"
                              name="cheque_no"
                              value={formData.cheque_no}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (/^\d{0,15}$/.test(val)) {
                                  handleChange(e);
                                }
                              }}
                              maxLength={15}
                              required
                            />
                          </div>
                          <div className="d-flex col-md-4 mt-2">
                            <div style={{ width: "100%", marginTop: '20px' }}>
                              {/* <label className="form-label">Cheque Layout *</label> */}
                              <PaginatedSearchSelect
                                api="preferenceCompanyData"
                                GetPaginatedData={GetPaginatedData}
                                placeholder="Select Cheque Layout"
                                value={selectedChequeLayout}
                                getOptionLabel={(opt) => opt.layout_name}
                                onSelect={(opt) => setSelectedChequeLayout(opt)}
                              />
                            </div>
                          </div>
                        </div>



                        <div
                          className="form-row d-flex col-md-16 mt-2"
                          style={{ marginLeft: "10px", marginLeft: "40px" }}
                        >
                          <label>
                            Do you want to add prepaid tax? &nbsp;
                            <input
                              type="checkbox"
                              id="prepaidTax"
                              onChange={handleCheckboxChange}
                              checked={formData.prepaid_tax}
                              name="prepaid_tax"
                            />
                          </label>
                        </div>
                        {formData.prepaid_tax && (
                          <div
                            className="form-row d-flex col-md-4 p-2 mt-2"
                            style={{
                              backgroundColor: "#fff",

                              borderRadius: "0px",
                              height: "52px",
                              marginLeft: "35px",
                            }}
                          >
                            <div className="input-group col-md-6">
                              <div
                                className="input-group-prepend"
                                style={{
                                  background: "#ffffff",
                                  height: "100%",

                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                { }
                              </div>
                              <input
                                type="text"
                                className="form-control-borderless"
                                placeholder="Amount"
                                aria-label="Prepaid Tax"
                                name="prepaid_amount"
                                value={formData.prepaid_amount || ""}
                                onChange={handleChange}
                                onInput={(e) => {
                                  e.target.value = e.target.value
                                    .replace(/[^0-9.]/g, "")
                                    .replace(/^(\d*\.?\d{0,2}).*/g, "$1")
                                    .slice(0, 12);
                                }}
                              />
                            </div>
                          </div>
                        )}

                        {/* Cheque Preview */}
                        {selectedChequeLayout && (
                          <div className="row mt-4 mx-3">
                            <div className="col-12">
                              <h6 style={{ marginBottom: "10px" }}>Cheque Preview</h6>
                              <div
                                style={{
                                  background: "#f8f9fa",
                                  padding: "10px",
                                  borderRadius: "8px",
                                  // overflowX: "auto",
                                  overflow: "auto",
                                  minHeight: "260px",
                                }}
                              >
                                <ChequeRenderer
                                  layout={selectedChequeLayout}
                                  chequeData={chequePreviewData}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {showBankFields && (
                      <div
                        className="d-flex col-md-12"
                        style={{ marginLeft: "37px" }}
                      >
                        <div className="d-flex col-md-6 mt-2">
                          <select
                            style={{
                              backgroundColor: "#fff",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              borderRadius: "0px",
                              height: "52px",
                              marginRight: "10px",
                            }}
                            className="input-select"
                            name="bank"
                            value={formData.bank}
                            onChange={handleChange}
                          >
                            <option value="">Select Bank</option>
                            {bank.map((bank) => (
                              <option key={bank.id} value={bank.id}>
                                {bank.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        { }
                      </div>
                    )}

                  </form>
                </div>
                <div
                  className="modal-footer"
                  style={{ border: "none", gap: "2%" }}
                >
                  <button
                    type="button"
                    className="btn btn-secondary-outline"
                    onClick={toggleModal}
                    style={{
                      border: " 1px solid #282e26",
                      borderRadius: "40px",
                      width: "181px",
                      height: "45px",
                      fontWeight: "bold",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn "
                    onClick={handleSubmit}
                    style={{
                      color: "white",
                      backgroundColor: "#282e26",
                      borderRadius: "40px",
                      width: "181px",
                      height: "45px",
                      fontWeight: "bold",
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <AddVendorModal
        show={showModalVendor}
        handleClose={handleCloseVendor}
        onVendorAdded={handleVendorAdded}
        updateVendors={updateVendors}
        serviceData={serviceData}
        onServiceDataUpdate={handleServiceDataUpdate}
      />
      <AddDepartmentModal
        show={showModalDepartment}
        handleClose={handleCloseModal}
        onDepartmentAdded={handleNewDepartment}
      />
      <ToastContainer />
    </div>
  );
}